import React from 'react'
import PropTypes from 'prop-types'

import currencyFormat from 'functions/currencyFormat'
import styles from './styles.scss'

const QuoteItem = (props) => {
  const {
    campaignQuoteItem: { display_title, price_override, row_title },
    showPrice,
  } = props

  return (
    <li className={styles.root}>
      <span className={styles.left}>
        {row_title && <span className={styles.rowTitle}>{row_title}</span>}
        <span>{display_title}</span>
      </span>

      {showPrice && <span className={styles.right}>{currencyFormat(price_override)}</span>}
    </li>
  )
}

QuoteItem.propTypes = {
  campaignQuoteItem: PropTypes.object.isRequired,
  showPrice: PropTypes.bool,
}

export default QuoteItem
